export const styles = {
    responsiveCenterContent: {
        justifyContent: { base: 'start', sm: 'center' },
        alignItems: { base: 'start', sm: 'center' },
    },
};
